<template>
    <div v-show="isAddNewAccountLicenseSuccessModalVisible">
        <transition name="slide">
            <div :class="type == 2 ? 'modal-mask' : 'modal-mask1'">
                <div class="modal-dialog modal-dialog-slideout modal-lg" style="max-width: 100%;">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="" style="width: 100%;">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                           </div>
                        </div>
                        <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h5 d-inline mr-2 text-uppercase">Subscriptions</div>
                              
                            </div>
                          </div>                            
                            <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                            <p class="success-msg">Success!</p>
                                            <p class="success-note">
                                                <i class="fa fa-check-circle-o"></i>Purchase Confirmed
                                            </p>
                                        </div>
                                        <div class="success_col_2">
                                            <img src="@/assets/enterprise/Required_Rocket_Image_106x101.png" width="70" />
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="success_col_3" v-if="invoice_filename">
                                            <a :href="invoice_filename" target="_blank" class="linkable"> View Receipt </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row list_row_margin">
                                <div class="col-12 text-center">
                                    <p class="font-weight-bold">What Happens Now?</p>
                                </div>
                                <div class="col-12">
                                    <ul class="list_items">
                                        <li>Primary admin creates password via system email</li>
                                        <li>Primary admin (or you) adds users</li>
                                        <li>Users complete required assessments, forms, and/or courses</li>
                                        <li>Training and progress tracking begins!</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row gotoBtn justify-content-md-center">
                                <div class="col-6">
                                    <button type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="openSidebar(accountId)">Go to Account</button>
                                </div>
                            </div>
                            <div class="row mt-4 justify-content-md-center">
                                <div class="col-6">
                                    <button type="button" class="btn btn-sm btn-blue closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <EnterpriseAdminOverlaySidebar
            :isModalVisible="isModalVisible" 
            @close="closeSidebar"
            ref="location_sidebar" 
            :readOnly="readOnly" 
        />

    </div>
</template>
<script>
import router from '../../router/index.js';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';

export default {
    props: ['isAddNewAccountLicenseSuccessModalVisible', 'accountId', 'invoice_filename', 'total', 'cc4_digit', 'type'],
    data() {
        return {
            loading: false,
            readOnly: false,
            isModalVisible: false,
            page_from_purchasing: false,
        }
    },
    components: {
        EnterpriseAdminOverlaySidebar,
    },
    methods: {
        hide() {
            this.closeModal();
        },
        closeModal() {
            let routeData = this.$router.resolve({name: 'locations'});
            window.open(routeData.href, '_self');
        },
        openSidebar(accountId) {
            router.push('/location-window/' + accountId);
            window.location.reload();
        },
        closeSidebar() {
            this.isModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 20px;
    border-radius: 10px;
}
.success-msg { font-size:  1.1rem; font-weight: 900;}
.success-note i { font-size: 1.05rem; margin-right: 10px; }
.gotoBtn { margin-top: 0rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.list_row_margin { margin: 2rem 0; }
.list_items { list-style-type: decimal; }
.list_items li { margin: 15px 0; }
.success_col_1 { width: 70%; float: left; }
.success_col_2 { width: 30%; float: left; }
.success_col_3 { width: 100%; text-align: center;}
.linkable { color: #FFF !important; text-decoration: underline !important; font-weight: 900; cursor:pointer; }
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_account_license_success_modal.vue